import { render, staticRenderFns } from "./SingPauseSchulenKlassen.vue?vue&type=template&id=01ba4438&"
import script from "./SingPauseSchulenKlassen.vue?vue&type=script&lang=js&"
export * from "./SingPauseSchulenKlassen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports